// Konflikt-Warnung bei wiederkehrenden Buchungen (belegte Termine werden
// übersprungen) — extrahiert aus AppointmentsPage.js.
import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const OverwriteWarningDialog = ({
  open, onOpenChange, conflictingDates, recurringOccurrences, onCancel, onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-amber-600 flex items-center gap-2">
          ⚠️ Einige Termine sind bereits belegt
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <p className="text-sm text-gray-700">
          Die folgenden Termine sind bereits belegt und werden <strong>übersprungen</strong>:
        </p>

        <div className="max-h-60 overflow-y-auto border rounded-md">
          <table className="w-full text-sm">
            <thead className="bg-gray-100 sticky top-0">
              <tr>
                <th className="px-4 py-2 text-left">Datum</th>
                <th className="px-4 py-2 text-left">Zeit</th>
                <th className="px-4 py-2 text-left">Bestehender Service</th>
                <th className="px-4 py-2 text-left">Kunde</th>
              </tr>
            </thead>
            <tbody>
              {conflictingDates.map((conflict, idx) => (
                <tr key={idx} className="border-t hover:bg-amber-50">
                  <td className="px-4 py-2">{conflict.date}</td>
                  <td className="px-4 py-2">{conflict.time}</td>
                  <td className="px-4 py-2 font-medium">{conflict.existingService}</td>
                  <td className="px-4 py-2">{conflict.existingCustomer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-md p-4">
          <p className="text-sm text-green-800 font-medium">
            ✅ <strong>{recurringOccurrences - conflictingDates.length}</strong> von <strong>{recurringOccurrences}</strong> Terminen werden gebucht
          </p>
          <p className="text-xs text-green-700 mt-1">
            Die {conflictingDates.length} bestehenden Termine bleiben unverändert.
          </p>
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={onCancel}
            className="flex-1"
          >
            Abbrechen
          </Button>
          <Button
            onClick={onConfirm}
            className="flex-1 bg-green-600 hover:bg-green-700"
          >
            Mit verfügbaren Terminen fortfahren
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
